/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/padlock'
export default icon
